export default __webpack_public_path__ + "cta-kirstie-product-shot-hand-desktop.png";